'use client'

import MapboxPolyline from '@component/mapbox/layer/polyline'
import useFetch from '@hooks/useFetch'
import { suburbsToIds } from '@plugin/searchRoute/utils'
import { get, size } from 'lodash-es'
import { useMemo } from 'react'
import { useEstimateMapContext } from '../../context'

export default function SuburbPolygon() {

  const { state: { suburbs } } = useEstimateMapContext()
  const suburbId = useMemo(() => {
    const { suburbIds } = suburbsToIds(suburbs).ids()
    if (size(suburbIds) === 1) {
      return suburbIds[0]
    }
  }, [suburbs])

  const { data } = useFetch({ url: suburbId ? `suburb/${suburbId}/boundary-with-nearby` : null })
  const boundary = get(data, 'main.boundary')

  return size(boundary) > 0 && (
    <MapboxPolyline data={boundary} width={1.6} id="estimate-map-suburb" color='#FF8500'></MapboxPolyline>
  )
}